import React from 'react';
import { useLingui } from '@lingui/react/macro';

import PetBlock from '@rover/components/src/PetBlock/PetBlock';
import { Flex, Heading } from '@rover/kibble/core';
import type { Pet } from '@rover/rsdk/src/apiClient/latest/model/pet';
import type { UnitEnum } from '@rover/rsdk/src/apiClient/latest/model/unitEnum';

type Props = {
  pets: Pet[];
  weightLabel: UnitEnum;
  onPetPressed: (pet: Pet) => void;
};

const RevampSitterPets = ({ pets, weightLabel, onPetPressed }: Props): JSX.Element | null => {
  const { t } = useLingui();
  if (pets.length === 0) return null;

  return (
    <Flex flexDirection="column" width="100%" data-testid="revamp-sitter-pets" py="10x">
      <Heading size="300">{t`Pets`}</Heading>
      <Flex flexWrap="wrap" gap="4x">
        {pets.map((pet) => (
          <Flex key={pet.opk || pet.name} flex={['1 1 100%', '1 1 calc(50% - 8px)']} minWidth="0">
            <PetBlock
              pet={pet}
              weightLabel={weightLabel}
              onPetPressed={onPetPressed}
              dataTestId={pet.name}
            />
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
};

export default RevampSitterPets;
